var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "profile-field__title" }, [
        _vm._v("Опыт работы"),
      ]),
      _c("c-switcher", {
        attrs: { label: "Есть опыт работы в сфере" },
        model: {
          value: _vm.hasExperience,
          callback: function ($$v) {
            _vm.hasExperience = $$v
          },
          expression: "hasExperience",
        },
      }),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.hasExperience
          ? _c(
              "div",
              {
                staticClass: "wrapper",
                class: {
                  "phone-error": _vm.error && _vm.error.phone,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "place" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Место последней работы в сфере",
                        clearable: true,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.organization,
                        callback: function ($$v) {
                          _vm.organization = $$v
                        },
                        expression: "organization",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "duration" }, [
                  _c("div", { staticClass: "c-input-label" }, [
                    _vm._v("Продолжительность"),
                  ]),
                  _c("div", { staticClass: "duration__wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "duration__value" },
                      [
                        _c("c-input", {
                          attrs: {
                            clearable: true,
                            placeholder: "0",
                            type: "price-number",
                          },
                          model: {
                            value: _vm.duration,
                            callback: function ($$v) {
                              _vm.duration = $$v
                            },
                            expression: "duration",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "duration__unit" },
                      [
                        _c("c-input", {
                          attrs: { type: "select", items: _vm.durationUnits },
                          model: {
                            value: _vm.durationUnit,
                            callback: function ($$v) {
                              _vm.durationUnit = $$v
                            },
                            expression: "durationUnit",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "position" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Занимаемая должность",
                        clearable: true,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.position,
                        callback: function ($$v) {
                          _vm.position = $$v
                        },
                        expression: "position",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "phone" },
                  [
                    _c("c-input", {
                      staticClass: "phone__input",
                      attrs: {
                        label:
                          "Телефон человека, который может дать рекомендацию",
                        clearable: true,
                        placeholder: "+7 (___) ___ ____",
                        mask: "+7 (###) ### ####",
                        required: _vm.error && _vm.error.phone,
                        "required-message": _vm.error && _vm.error.phone,
                      },
                      model: {
                        value: _vm.phone,
                        callback: function ($$v) {
                          _vm.phone = $$v
                        },
                        expression: "phone",
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }